import { types } from './crudIntegracao.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'
import { TIPOS, FORMATOS } from './constants'

const initialState = {
  id: 'crudIntegracao',
  selectedFilters: [],
  showHideColumns: [
    {
      label: 'Código',
      value: {
        field: 'oid',
        header: 'Código',
        columnKey: 'oid',
        sortable: true,
        columnSortField: 'oid',
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Nome',
      value: {
        field: 'nome',
        header: 'Nome',
        columnKey: 'nome',
        sortable: true,
        columnSortField: 'nome',
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Unidade',
      value: {
        field: 'unidade_sigla',
        columnKey: 'unidade.sigla',
        sortable: true,
        header: 'Unidade',
        filter: true,
        columnSortField: 'unidade.sigla',
        relacionamento: ['unidade'],
        fieldJoin: 'sigla',
        visible: true,
      },
    },
    {
      label: 'Tipo',
      value: {
        field: 'tipo',
        header: 'Tipo',
        columnKey: 'tipo',
        sortable: true,
        columnSortField: 'tipo',
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Formato',
      value: {
        field: 'formato',
        header: 'Formato',
        columnKey: 'formato',
        sortable: true,
        columnSortField: 'formato',
        filter: true,
        visible: true,
      },
    },
  ],
  columnsLookup: [
    {
      field: 'oid',
      header: 'Código',
      columnKey: 'oid',
      sortable: true,
      columnSortField: 'oid',
      filter: true,
      visible: true,
    },
    {
      field: 'nome',
      header: 'Nome',
      columnKey: 'nome',
      sortable: true,
      columnSortField: 'nome',
      filter: true,
      visible: true,
    },
  ],
  columns: [],
  currentRecord: {
    oid: '',
    nome: '',
    unidade: '',
    tipo: TIPOS[0],
    consultaSql: '',
    requisicao: '',
    formato: FORMATOS[0],
  },
  messages: null,
  usaListDto: false,
}

const reducer = new Reducer(initialState, types)

export function CRUDIntegracaoReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels('crudIntegracao')
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  switch (action.type) {
    case types.RESET:
      return reset(state, action)
    default:
      return state
  }
}

function reset(state, action) {
  return { ...state, currentRecord: initialState.currentRecord, records: [], selectedFilters: [] }
}
